import React, { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { Box } from '@rebass/emotion';
import { ErrorMessage as HookFormErrorMessage } from '@hookform/error-message';
import styled from '@emotion/styled';
import { rem } from '../styles/theme/layout';
import theme from '../styles/theme';

export const FormErrorMessage = styled.div`
  position: relative;
  padding-left: ${rem(20)};
  color: ${theme.colors.red};
  font-size: ${rem(14)};

  &::before {
    position: absolute;
    top: 0;
    left: 0;
    content: '✖';
  }
`;

const HookFormErrors: FC<{ fields: string[]; namespace?: string }> = ({
  fields,
  namespace,
}) => {
  const { errors } = useFormContext();
  return (
    <>
      {fields.map((fieldName) => (
        <HookFormErrorMessage
          key={namespace ? `${namespace}.${fieldName}` : fieldName}
          errors={errors}
          name={namespace ? `${namespace}.${fieldName}` : fieldName}
          render={({ message }) => (
            <Box mb={10} width={1}>
              <FormErrorMessage data-testid={`error-${namespace}-${fieldName}`}>
                {message}
              </FormErrorMessage>
            </Box>
          )}
        />
      ))}
    </>
  );
};
export default HookFormErrors;
